import { useTranslation } from 'react-i18next'

import Button from '../../../Button'
import { QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_ADD_NEW_ACTIVITY } from '../RequestProfileTabActivities.constants'

import PlusIcon from '../../../../icons/plus.svg'

function RequestProfileTabActivitiesAddActivityButton({ className, onClick }) {
  const { t } = useTranslation()

  return (
    <Button.Text
      beforeIconProps={{ Icon: PlusIcon }}
      className={className}
      qaName={QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_ADD_NEW_ACTIVITY}
      text={t('RequestProfileTabActivities.AddNewActivityBtnKey')}
      onClick={onClick}
    />
  )
}

export default RequestProfileTabActivitiesAddActivityButton
